import React from "react";
import FlightTicketScreen from "../../../common/AllTickets/Flight/FlightTicketScreen";

function SuperFlightTicket() {
  return <FlightTicketScreen mode="ADMIN" />;
}

export default SuperFlightTicket;
